module.exports = __webpack_public_path__ + "videos/whats-new_jp.4092d19.mp4";